import React from 'react'

import Loading from '../components/loading'
import request from '../util/request'
import StateChangeSummary from '../components/state-change-summary'
import statesToArray from '../util/states-to-array'
import TopBottomToggle from '../components/top-bottom-toggle'

class TopBottom extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      data: {},
      display: 'top-rank',
    }
    this.onDisplayChange = this.onDisplayChange.bind(this)
  }

  componentWillMount() {
    const { data } = this.state
    /* istanbul ignore next */
    if (!data.ranking) {
      this.loadJSON('ranking')
    }
  }

  onDisplayChange(value) {
    this.setState({ display: value })
  }

  async loadJSON(name) {
    const newData = await request(`/data/${name}.json`)
    this.setState(prevState => ({
      data: {
        ...prevState.data,
        [name]: newData,
      },
    }))
  }

  statesByRank() {
    const { data } = this.state
    return statesToArray(data.ranking).sort(
      (a, b) => parseInt(a.rank, 10) > parseInt(b.rank, 10) ? 1 : -1,
    )
  }

  statesByIndicatorImprovement() {
    const { data } = this.state
    return statesToArray(data.ranking).sort(
      (a, b) => {
        const aInd = parseInt(a.ind, 10)
        const bInd = parseInt(b.ind, 10)
        return (aInd < bInd || (aInd === bInd && a.state > b.state)) ? 1 : -1
      },
    )
  }

  displayStates(display) {
    let states
    if (['top-rank', 'bottom-rank'].includes(display)) {
      states = this.statesByRank()
      if (display === 'top-rank') {
        // This is a hack on which removes Vermont from the top 5, due to a tie with Connecticut. There 
        // was no logic on which to base this decision on.
        states = states.filter(function (value) {
          return value['state'] !== 'VT';
        }).slice(0, 5)
      } else {
        states = states.reverse().slice(0, 5).reverse()
      }
      return states.map(
        (state, index) => {
          const change =
            parseInt(state.base_rank, 10) - parseInt(state.rank, 10)
          const roseFell = change > 0 ? 'Rose' : 'Fell'
          const places = Math.abs(change) === 1 ? 'place' : 'places'
          const summary = change === 0 ?
            'No change in ranking.' :
            `${roseFell} ${Math.abs(change)} ${places} in ranking.`
          return (<StateChangeSummary
            key={state.state}
            index={(display === 'top-rank') ? index + 1 : index + 47}
            state={state.state}
            summary={summary}
          />)
        },
      )
    }
    states = this.statesByIndicatorImprovement()
    if (display === 'top-improve') {
      states = states.slice(0, 5)
    } else {
      states = states.reverse().slice(0, 5).reverse()
    }
    return states.map(
      (state, index) => {
        const indicators = state.ind === 1 ? 'indicator' : 'indicators'
        const summary =
          `Improved on ${state.ind} ${indicators}.`
        return (<StateChangeSummary
          index={(display === 'top-improve') ? index + 1 : index + 47}
          key={state.state}
          state={state.state}
          summary={summary}
        />)
      },
    )
  }

  render() {
    const { data, display } = this.state
    if (!data.ranking) {
      return (<Loading message="Loading data..." />)
    }
    return (
      <div className="top-bottom">
        <TopBottomToggle value={display} changeHandler={this.onDisplayChange} />
        <div className="cmwf--state-change-summaries">
          {this.displayStates(display)}
        </div>
      </div>
    )
  }
}


export default TopBottom



// WEBPACK FOOTER //
// ./src/components/Visualizations/containers/top-bottom.jsx